import { types, flow, getSnapshot } from 'mobx-state-tree';;

import { makeRequest, url } from 'js/services/Network';
import { castEventToValue } from 'js/services/FormTools';
import AnonymousId from 'js/services/AnonymousId';

import SteppedPage from 'js/stores/SteppedPage';
import Address from '../types/Address';
import img from "images/missing-image.svg";

const CreateItemPageState = types
  .model('CreateItemPage', {
    isSubmitting: false,
    modalIsVisible: true,
    error: types.maybeNull(types.string),
    anonymous_id: AnonymousId,
    currentStep: 1,

    isHoveringFiles: false,
    isUploadingFiles: false,
    uploadFilesError: '',
    requestInProgress: false,

    hasEnteredTitle: false,
    hasEnteredPrice: false,
    hasEnteredQuantity: false,
    hasSelectedSize: false,
    hasEnteredAddress: false,

    primary_image: img,
    primary_image_state: false,
    title: '',
    price: '',
    quantity: '1',
    size: '',
    address: types.optional(Address, {}),
    withSignup: false,
  })
  .actions(self => {
    return {
      getStepRoute() {
        return url('items.create');
      },

      initStep() {
        self.modalIsVisible = false;
        return self;
      },

      load: flow(function* load() {
        const response = yield makeRequest('create-payment-link-data', self);
        self.address = response.data.address || {};
        self.title = new URLSearchParams(window.location.search).get('title') || '';
        self.hasEnteredTitle = self.title.length > 0;
      }),

      setWithSignup(withSignup) {
        self.withSignup = withSignup;
        return self;
      },

      setIsSubmitting(val) {
        self.isSubmitting = val;
        return self;
      },

      setError(message) {
        self.error = message;
        return self;
      },

      onUpload(image_url) {
        self.primary_image = image_url;
        self.primary_image_state = true;
      },

      openModal() {
        self.modalIsVisible = true;
        return self;
      },

      closeModal() {
        self.modalIsVisible = false;
        return self;
      },

      nextDetail() {
        self.hasEnteredQuantity = self.quantity > 0;

        const stepOne = self.primary_image_state && self.hasEnteredTitle && self.hasEnteredPrice && self.hasEnteredQuantity
        const stepTwo = stepOne && !self.hasSelectedSize
        const stepThree = stepOne && self.hasSelectedSize && !self.hasEnteredAddress
        const stepFour = stepOne && self.hasSelectedSize && self.hasEnteredAddress

        if (stepTwo) self.currentStep = 2;
        if (stepThree) self.currentStep = 3;
        if (stepFour) self.currentStep = 4;
      },

      setTitle(title) {
        self.title = castEventToValue(title);
        self.hasEnteredTitle = self.title.length > 0
        return self;
      },

      setPrice(price) {
        self.price = castEventToValue(price);
        self.hasEnteredPrice = true;
        return self;
      },

      setQuantity(quantity) {
        self.quantity = castEventToValue(quantity);
        self.hasEnteredQuantity = self.quantity > 0;
        return self;
      },

      setSize(size) {
        self.size = castEventToValue(size);
        self.hasSelectedSize = true;
        return self;
      },

      addressSaved(savedAddress) {
        self.address.setAddress(savedAddress);
        self.hasEnteredAddress = true;
        self.modalIsVisible = false;
      },
    };
  });

export default types.compose(
  SteppedPage,
  CreateItemPageState,
);
